<template>
  <div class="geofence-fields-airport">
    <div class="row margin-T">
      <div class="small-4 columns">
        <label class="checkbox-input">
          <input type="checkbox" v-model="geofence.trackEntryExit"
            @change="updateField('trackEntryExit')" />
          <span>TRACK ENTRY AND EXITS</span>
        </label>
      </div>
      <div class="small-4 columns">
        <label class="checkbox-input">
          <input type="checkbox" v-model="geofence.showInAppBanner"
            @change="updateField('showInAppBanner')" />
          <span>SHOW BANNER IN PROVIDER APP</span>
        </label>
      </div>
      <div class="small-4 columns">
        <label class="checkbox-input">
          <input type="checkbox" v-model="geofence.pushNotificationToProvUponEntry"
            @change="updateField('pushNotificationToProvUponEntry')" />
          <span>PUSH ENTRY NOTIFICATIONS</span>
        </label>
      </div>
    </div>

    <div class="row margin-T">
      <div class="small-4 columns padding-R">
        <div class="input-field">
          <label>ON DECK - TIMEOUT</label>
          <input type="number" placeholder="in Seconds"
            v-model="geofence.onDeckTimeout" />
        </div>
      </div>

      <div class="small-4 columns padding-L padding-R">
        <div class="input-field">
          <label>ON DECK - NUMBER OF CHANCES</label>
          <input type="number"
            v-model="geofence.numberOfChances"/>
        </div>
      </div>

      <div class="small-4 columns padding-R">
        <div class="input-field">
          <label>ACTIVE TIMER PASSENGER LOADING</label>
          <input type="number" placeholder="in Minutes"
            v-model="geofence.activeTimer"/>
        </div>
      </div>
    </div>
    <div class="row margin-T">
      <div class="small-12 columns">
        <div class="input-field">
          <label>APPLICABLE SERVICE TYPES</label>
        </div>
      </div>
    </div>

    <div class="service-list" v-for="brand in brands" v-if="serviceList(brand.id).length">
      <div class="brand">{{ brand.name }}</div>

      <div class="row">
        <div v-for="service in serviceList(brand.id)" class="column medium-3 end">
          <label class="service">
            <input type="checkbox" :value="service.id" v-model="geofence.serviceTypeIds" @click="addServiceID(service.id)"/>
            {{ service.label }}
          </label>
        </div>
      </div>
    </div>

    <div class="service-list">
      <div class="brand">LEGACY</div>

      <div class="row">
        <div class="small-3 columns end">
          <label class="service">
            <input type="checkbox" v-model="checkService.shared" />
            <span>{{ serviceLabel('shared') }}</span>
          </label>
        </div>
        <div class="small-3 columns end">
          <label class="service">
            <input type="checkbox" v-model="checkService.opoli" />
            <span>{{ serviceLabel('opoli') }}</span>
          </label>
        </div>
        <div class="small-3 columns end">
          <label class="service">
            <input type="checkbox" v-model="checkService.black" />
            <span>{{ serviceLabel('black') }}</span>
          </label>
        </div>
        <div class="small-3 columns end">
          <label class="service">
            <input type="checkbox" v-model="checkService.suv" />
            <span>{{ serviceLabel('suv') }}</span>
          </label>
        </div>
        <div class="small-3 columns end">
          <label class="service">
            <input type="checkbox" v-model="checkService.shuttle" />
            <span>{{ serviceLabel('shuttle') }}</span>
          </label>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import services from '@/modules/api/services'
// import stagingGeofenceAPI from '@/modules/api/geofences/staging'

export default {
  name: 'geofence-fields-staging',
  props: [ 'geofence' ],
  data () {
    return {
      checkService: {
        shared: false,
        opoli: false,
        black: false,
        suv: false,
        shuttle: false
      },
      serviceLoading: false
    }
  },
  computed: {
    brands () { return this.$store.state.brands.list },
    accountType () { return this.$store.state.provider.accountType.type }
  },
  methods: {
    serviceList (brandId) { return this.$store.state.services.list.filter(x => x.brandId === brandId && x.enabled) },
    updateField (field) {
      this.$store.commit('geofences/setGeofenceField', {
        id: this.geofence.id,
        field: field,
        value: this.geofence[field] ? 1 : 0
      })
    },
    serviceLabel (code) { return services.getServiceName(code) },
    addServiceID(id) {
      let self = this
      if(typeof this.geofence.serviceTypeIds === "boolean" || this.geofence.serviceTypeIds === null) {
        self.geofence.serviceTypeIds = [id]
      }
    }
  },
  watch: {
    geofence: function (value) {
      if (value) {
        if (!value.services) {
          this.checkService.shared = false
          this.checkService.opoli = false
          this.checkService.black = false
          this.checkService.suv = false
          this.checkService.shuttle = false
        } else {
          this.checkService.shared = value.services.shared ? value.services.shared.allowed : false
          this.checkService.opoli = value.services.opoli ? value.services.opoli.allowed : false
          this.checkService.black = value.services.black ? value.services.black.allowed : false
          this.checkService.suv = value.services.suv ? value.services.suv.allowed : false
          this.checkService.shuttle = value.services.shuttle ? value.services.shuttle.allowed : false
        }
      }
    },
    'checkService.shared': function (value) { this.geofence.services.shared.allowed = value },
    'checkService.opoli': function (value) { this.geofence.services.opoli.allowed = value },
    'checkService.black': function (value) { this.geofence.services.black.allowed = value },
    'checkService.suv': function (value) { this.geofence.services.suv.allowed = value },
    'checkService.shuttle': function (value) { this.geofence.services.shuttle.allowed = value }
  },
  mounted () {
    if (this.geofence.services) {
      this.checkService.shared = this.geofence.services.shared ? this.geofence.services.shared.allowed : false
      this.checkService.opoli = this.geofence.services.opoli ? this.geofence.services.opoli.allowed : false
      this.checkService.black = this.geofence.services.black ? this.geofence.services.black.allowed : false
      this.checkService.suv = this.geofence.services.suv ? this.geofence.services.suv.allowed : false
      this.checkService.shuttle = this.geofence.services.shuttle ? this.geofence.services.shuttle.allowed : false
    }
  }
}
</script>

<style lang="scss" scoped>
.input-field {
  font-size: 14px;

  & label {
    font-size: 12px;
    font-weight: 700;
    color: #0D79F2;
  }

  & input, & textarea {
    margin-top: 0;
    padding: 7px 10px;
  }

  & textarea {
    resize: none;
    height: 100px;
  }
}

.checkbox-input {
  & > * {
    display: inline-block;
    vertical-align: middle;
    width: auto;
  }
  & input {
    margin-top: 0;
  }
  & span {
    font-size: 12px;
    font-weight: 700;
    color: #777;
    height: 16px;
    margin-left: 3px;
    cursor: pointer;
  }
}

.service-list{
  padding: 0 30px;
  margin-bottom: 10px;

  .brand{
    font-weight: 600;
    font-size: 14px;
  }
  .service{
    cursor: pointer;
    font-size: 13px;
    color: #333;
  }
  input{
    margin: 0;
    width: 20px;
    display: inline-block;
    vertical-align: -1px;
  }
}

.padding-L { padding-left: 7px; }
.padding-R { padding-right: 7px; }
.margin-T { margin-top: 15px; }

@media only screen and (max-width: 430px) {
  .padding-R, .padding-L {
    padding: 0;
  }

  .small-2, .small-5, .small-6, .small-3, .small-4, .small-8 {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Geofences/GeofenceFieldsStaging.vue